import ApiService from '../api.service';
const HealthService = {
    getSystemStatus: async () => {
        let response = await ApiService.get('health/systemStatus');
        return response.data;
    }
};

export default HealthService;
